import { Component } from '@angular/core';
import { CMSPortalService } from '../../shared/service/cms-portal.service';
import { Imagem } from '../../shared/model/imagem.model';
import { Router } from '@angular/router';

const MAX_IMAGENS_DESTAQUE_COUNT = 4

@Component({
  selector: 'app-conteudo-destaque',
  templateUrl: './destaque.component.html',
  styleUrls: ['./destaque.component.css']
})
export class DestaqueComponent {

  public listaDestaques: Imagem[] = [];

  constructor(private service: CMSPortalService,
              private router: Router) {
    this.getSlider();
  }

  getSlider() {
    this.service.getDestaqueImagem(MAX_IMAGENS_DESTAQUE_COUNT).subscribe(res => {
      const conteudo: Array<Imagem> = res.conteudo;
      this.listaDestaques = conteudo? conteudo.slice(0, MAX_IMAGENS_DESTAQUE_COUNT): [];
    });
  }

  pesquisarSite(texto: string) {
    this.router.navigate(['/pesquisa', texto]);
  }

}
